import { render, staticRenderFns } from "./HardwordReactive.vue?vue&type=template&id=6cd252f3"
import script from "./HardwordReactive.vue?vue&type=script&lang=js"
export * from "./HardwordReactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports